<template>
    <div class="row">
      <table class="table">
        <thead>
        <tr>
          <th scope="col">Rank</th>
          <th scope="col">Name</th>
          <th scope="col">Score</th>
          <th scope="col">Submitted At</th>
        </tr>
        </thead>
  
        <tbody>
  
        <tr v-if="dataList.length === 0">
          <td colspan="4" class="text-center">Empty data list</td>
        </tr>
  
        <tr v-for="(data) in dataList" :key="data">
            <td class="text-center">{{ data.rank }}</td>
            <td class="text-left font-weight-bold">{{ data.memberName }}</td>
            <td class="text-center">{{ data.score }}</td>
            <td class="text-center">{{ fmtDate(data.finishedAt) }}</td>
        </tr>

        </tbody>

      </table>
    </div>
  </template>
  
  <script>
  import {defineComponent} from 'vue'
  import apiService from "@/services/ApiService";
  import moment from "moment";

  export default defineComponent({
    name: "QuizWinnerList",
    props: {
      quizId: {
        type: String,
        required: true
      }
    },
    components: {
    },
    data() {
      return {
        dataList: [{
          id: '',
          memberId: '',
          memberName: '',
          rank: '',
          score: '',
          finishedAt: ''
        }],
      }
    },
    methods: {
        getWinners() {
            apiService.get(`/quiz/${this.quizId}/winners`)
                .then(response => {
                    console.log(response.data);
                    this.dataList = response.data;
                })
                .catch(error => {
                    console.log(error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Failed to get quiz winners',
                        detail: error.response.data.Message,
                        life: 5000
                    });
                });
        },
        fmtDate(date) {
            if(date === null || date === undefined || date === ''){
            return '';
            }
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
        }
    },
    mounted() {
      this.dataList = [];
      this.getWinners();
    }
  })
  </script>
  
  <style scoped>
  
  </style>
  